import React, { useState, useEffect, useContext } from 'react'
import { Tooltip } from '@mui/material'
import { BufferService, LoadingContext, M_InputTextField, M_DrawerTableTextField, M_StateActions, NavigateContext } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { MMap } from 'src/components/M_Components'
import axios from 'axios'
import './formsTable.css'

export default function CreateCity() {
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [dataCity, setDataCity] = useState(new Map())
    const [optionsCity, setOptionsCity] = useState([])
    const [cityId, setCityId] = useState("")
    const [operation, setOperation] = useState("")
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const bufferServiceCity = new BufferService('City')
    const { t } = useTranslation()
    const [points, setPoints] = useState([])
    const sessionKeys = ['dataCity', 'optionsCity', 'cityId', 'operation']


    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstLoop(false)
        }
        // eslint-disable-next-line 
    }, [])

    // eslint-disable-next-line 
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key) => {
            tempArray.push(sessionStorageMachine(id, key, key))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, dataCity, optionsCity, cityId, operation])

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempDC = M_StateData.filter(obj => obj.key === `dataCity`)[0]?.value
            const tempOC = M_StateData.filter(obj => obj.key === `optionsCity`)[0]?.value
            const tempCI = M_StateData.filter(obj => obj.key === `cityId`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            if (tempDC || tempOC || tempCI || tempOP) {
                setDataCity(new Map(tempDC))
                setOptionsCity(tempOC)
                setCityId(tempCI)
                setOperation(tempOP)
                ctx.setIsLoad(false)
                return
            }
        }
        getCity()
    }

    const getCity = () => {
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))
        setOperation(getOperation)
        setCityId(getId)

        ctx.setIsLoad(true)
        bufferServiceCity.options().then((responseOptions) => {
            if (responseOptions.name === 'AxiosError') {
                ctx.toastMessages('error', responseOptions.response.data.Errors[0], '')
                return
            }
            const filteredOptions = responseOptions.filter((option) => !option.IsHiddenList)
            setOptionsCity(filteredOptions)

            if (getOperation === 'edit') {
                bufferServiceCity.getId(getId).then((response) => {
                    if (response.name === 'AxiosError') {
                        ctx.toastMessages('error', response.response.data.Errors[0], '')
                        ctx2.closeTab(id)
                        return
                    }
                    const valueDataCity = response
                    responseOptions.forEach(obj => {
                        dataCity.set(obj.Name, valueDataCity[obj.Name])
                    })
                    setPoints([
                        {
                            latitude: valueDataCity.Latitude,
                            longitude: valueDataCity.Longitude,
                        }
                    ])
                    setDataCity(new Map(dataCity))
                    ctx.setIsLoad(false)
                })
            }
        })
        ctx.setIsLoad(false)
    }

    const cityStructure = (event, index) => {
        const cityName = dataCity.get('Name')
        dataCity.set(index, event)
        setDataCity(new Map(dataCity))

        if (!cityName || cityName.length < 3) return

        axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${cityName}.json?access_token=pk.eyJ1Ijoiam9hb21hcmFjbyIsImEiOiJjbTRrMzFyYzQwODBtMm1zMWg1emp2cDE4In0.ZKCrjBBIPyf9k1DU-uyqSQ`).then((response) => {
            const tempPoint = response.data.features[0]?.center
            if (tempPoint) {
                setPoints([{
                    latitude: tempPoint[1],
                    longitude: tempPoint[0],
                }])

                dataCity.set('Latitude', tempPoint[1])
                dataCity.set('Longitude', tempPoint[0])
                setDataCity(new Map(dataCity))
            }

        })
    }

    const submitCity = () => {
        const requiredFieldsCity = optionsCity.filter((elem) => elem.IsRequired)
        for (const field of requiredFieldsCity) {
            if (!dataCity.has(field.Name) || !dataCity.get(field.Name)) {
                ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                return
            }
        }
        ctx.setIsLoad(true)

        if (operation === 'edit') {
            bufferServiceCity.update(cityId, Object.fromEntries(dataCity)).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", '', t("ErrorUpdate"))
                    ctx.setIsLoad(false)
                    return
                }
                ctx.toastMessages("success", '', t("SuccessUpdate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        } else {
            bufferServiceCity.post(Object.fromEntries(dataCity)).then((response) => {
                if (response.name === 'AxiosError') {
                    if (response.response.data.Errors[0] === 'DuplicateCityCode') {
                        ctx.toastMessages("error", '', t(response.response.data.Errors[0]))
                        ctx.setIsLoad(false)
                        return
                    } else {
                        ctx.toastMessages("error", '', t("ErrorCreate"))
                        ctx.setIsLoad(false)
                        return
                    }

                }
                ctx.toastMessages("success", '', t("SuccessCreate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        }
    }

    return (
        <div className='backgroundForms'>
            <div className="display">
                <div className="menuIcon">
                    <Tooltip title={t("Close")} className='iconsHeaderTable'>
                        <div className='iconsHeaderTable' onClick={() => ctx2.closeTab(id)}>
                            <i className="pi pi-arrow-left iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Close")}</b></span>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Save")}>
                        <div className='iconsHeaderTable' onClick={submitCity}>
                            <i className="pi pi-save iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Save")}</b></span>
                        </div>
                    </Tooltip>
                </div>
            </div>
            <div className='dividerMenu'></div>
            <div className='divAlignFormPriceZone'>
                <div className='divFormPriceZone'>
                    {optionsCity.map((elem) => (
                        <div key={elem.Name}>
                            {elem.Type === 'string' ? (
                                elem.IsForeignKey ? (
                                    <M_DrawerTableTextField
                                        tableLabel={elem.NormalizedName}
                                        label={elem.NormalizedName}
                                        required={elem.Required}
                                        entity={elem.ForeignTableName}
                                        value={dataCity.get(elem.ForeignTableToPassId) ?
                                            {
                                                [elem.ForeignTableToPassId]: dataCity.get(elem.ForeignTableToPassId),
                                                [elem.ForeignKeyName]: dataCity.get(elem.Name)
                                            } : null}
                                        filterField={elem.ForeignKeyName}
                                        labelFields={[elem.ForeignKeyName]}
                                        onSubmitValue={obj => {
                                            if (obj) {
                                                dataCity.set(elem.Name, obj[elem.ForeignKeyName])
                                                dataCity.set(elem.ForeignTableToPassId, obj[elem.ForeignTableToPassId])
                                            } else {
                                                dataCity.set(elem.Name, null)
                                                dataCity.set(elem.ForeignTableToPassId, null)
                                            }
                                            setDataCity(new Map(dataCity))
                                        }}
                                        disabled={elem.disable}
                                        valueField={elem.ForeignTableToPassId}
                                    />
                                ) : (
                                    < M_InputTextField
                                        type={"text"}
                                        label={elem.NormalizedName}
                                        secondColor={"var(--color-red-dark)"}
                                        required={elem.IsRequired}
                                        onChange={(e) => cityStructure(e.target.value, elem.Name)}
                                        value={dataCity.get(elem.Name) || ""}
                                    />
                                )
                            ) : elem.Type === 'int32' ? (
                                < M_InputTextField
                                    type={"number"}
                                    label={elem.NormalizedName}
                                    secondColor={"var(--color-red-dark)"}
                                    required={elem.IsRequired}
                                    onChange={(e) => cityStructure(e.target.value, elem.Name)}
                                    value={dataCity.get(elem.Name) || ""}
                                />
                            ) : ""}
                        </div>
                    ))}
                </div>

                <div className='mapPriceZone'>
                    <MMap
                        height={"450px"}
                        navigationControl
                        controlScale
                        fullscreen
                        findMyLoc
                        satelliteView
                        pointGet
                        numberGetPoints={1}
                        points={points}
                        setPoints={setPoints}
                        initalMapState={{ latitude: dataCity.get('Latitude'), longitude: dataCity.get('Longitude') }}
                    />
                </div>

            </div>
        </div>
    )
}